/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Update = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
